import { define } from '@rlean/core';

const ActivePage = define('activePage', {
  initialState: { key: null, title: null },
});

export default ActivePage;
